import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// エントリー協業パートナー取得
export async function getSaleCompanyCollaborateCompanys(id: string) {
  try {
    const path = "saleCompanyCollaborateCompanys";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      collaborateCompanys: response.data.collaborate_company,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// エントリー協業パートナー登録
export async function postSaleCompanyCollaborateCompanys(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "saleCompanyCollaborateCompanys";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
